import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import AddGeneButton from './AddGeneButton';

const FullGeneList = ({ map, genePMTilesLocation, catalogId, geneList }) => {


  const renderViewButton = (params) => {
    return (
      <AddGeneButton
        row={params.row}
        gene_field='gene'
        map={map}
        genePMTilesLocation={genePMTilesLocation}
        catalogId={catalogId}
      />
    )
  }

  const columns = [
    {
      field: 'gene', headerName: 'Gene', flex: 2,
      renderCell: renderViewButton,
      disableClickEventBubbling: true,
    },
    {
      field: 'count', headerName: 'Count', flex: 1,
      type: 'number', disableClickEventBubbling: true
    }
  ];

  return (
    <>
      <DataGrid
        disableRowSelectionOnClick
        rows={geneList}
        sx={{ color: '#AAA' }}
        columns={columns}
        getRowId={(row) => row.gene}
        rowHeight={25}
        hideFooter={false}
        // autoHeight={true}
        density='compact'
        disableColumnSelector
        disableDensitySelector
        slotProps={{
          toolbar: {
            showQuickFilter: true,
          },
        }}
        components={{
          Toolbar: GridToolbar,
        }}
        initialState={{
          pagination: { paginationModel: { pageSize: 50 } },
          sorting: {
            sortModel: [{ field: 'count', sort: 'desc' }],
          },
        }}
      />
    </>
  )
}

export default FullGeneList;